import { StorageScope } from "../../../../services/api/instances/storageApi/types/service_types";
import { LAST_SELECTED_KEY } from "../constants";
import { LastSelectedEntry } from "../types";

export const clearLastSelectedId = (service: StorageScope): void => {
  try {
    const raw = localStorage.getItem(LAST_SELECTED_KEY);
    if (!raw) return;

    const data: Record<string, LastSelectedEntry> = JSON.parse(raw);
    delete data[service];
    localStorage.setItem(LAST_SELECTED_KEY, JSON.stringify(data));
  } catch (e) {
    console.warn("Failed to clear last selected object in localStorage", e);
  }
};
